import { modalOverrides, sponsorModal, textModal } from "./common"

const modalFields = {
    modalOverrides: textModal(),
    modal: sponsorModal("Booth 3", "KPMG", 
    <>
        KPMG firms can help you create a resilient and trusted digital world — even in the face of evolving threats. KPMG
        cyber security professionals can offer a multidisciplinary view of risk, enabling you to carry security throughout 
        your organisation, so you can anticipate tomorrow, move faster and get an edge with secure and trusted 
        technology.
        No matter where you are on your cyber security journey, KPMG firms have expertise across the continuum — 
        from the boardroom to the data center. In addition to assessing your cyber security and aligning it to your 
        business priorities, we can help you develop advanced solutions, assist with implementing them, advise on 
        monitoring ongoing risks and help you respond effectively to cyber incidents. KPMG professionals harness 
        constantly evolving technologies that can connect and power businesses forward – building trust and creating and
        protecting value, while bridging the gap between past and future.
        Let's create a trusted digital world together.
    </>, {
        twitter: "https://twitter.com/kpmg",
        facebook: "https://www.facebook.com/KPMG",
        instagram: "https://www.instagram.com/kpmg/",
        youtube: "https://www.youtube.com/kpmg",
        company: "https://home.kpmg/cybersecurity",
        contactUs: "https://home.kpmg/xx/en/home/misc/contact.html"
    })
}

export default [
    {
        width: "10.3%",
        height: "19%",
        left: "24.1%",
        top: "66%",
        label: "KPMG - Assume Nothing, verify everything",
        href: "https://assets.swoogo.com/uploads/2169948-636293d542052.pdf",
        target: "_blank"
    },
    {
        width: "10.3%",
        height: "19%",
        left: "11.1%",
        top: "66%",
        label: "KPMG - Contact Us",
        onClick: () => {
            document.getElementById("KPMG").click()
        }
    },
    {
        width: "7.6%",
        height: "19%",
        left: "46.1%",
        top: "63%",
        label: "CEO Outlook Report",
        href: "https://assets.swoogo.com/uploads/2169978-636296d9dd143.pdf",
        target: "_blank"
    },
    {
        width: "8.8%",
        height: "7%",
        left: "28%",
        top: "33%",
        label: "KPMG - Social Media",
        isExternal: true,
        ...modalFields
    },
    {
        width: "13.8%",
        height: "13%",
        left: "76%",
        top: "13%",
        label: "KPMG - Social Media",
        isExternal: true,
        ...modalFields
    },
    {
        width: "13.8%",
        height: "16%",
        left: "43%",
        top: "42.5%",
        label: "KPMG - Main Video",
        modalOverrides,
        modal: <div style={{height: "100%", width: "100%"}}>
            <iframe width="100%" height="100%" frameBorder="0"  src="https://player.vimeo.com/video/768176174?h=4e17d94ed1&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay/>
        </div>
    },
    {
        width: "15.8%",
        height: "18%",
        left: "74.6%",
        top: "44.5%",
        label: "KPMG - View Demo",
        modalOverrides,
        modal: <div style={{height: "100%", width: "100%"}}>
            <iframe width="100%" height="100%" frameBorder="0"  src="https://player.vimeo.com/video/768177892?h=4c61e75160&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay/>
        </div>
    }
]